module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Gc-Da-Ea.8ef065f9.png";